import { PayloadAction } from "@reduxjs/toolkit";
import translations from "constants/translations.json";

// State definition
export type LanguageState = {
  language: LanguageTypes;
  supportedLangs: { name: LanguageTypes; text: string }[];
};

// Action types definition
export enum LanguageActionTypes {
  SET_LANGUAGE = "@@language/SET_LANGUAGE",
}

// Additional definitions used in action objects
export type LanguageTypes = keyof typeof translations;
type SetLanguageAction = PayloadAction<LanguageTypes, LanguageActionTypes.SET_LANGUAGE>;
export type LanguageActions = SetLanguageAction;
